module.exports = __webpack_public_path__ + "img/fe_backdrop_emblem_hannibal.c2325f4d.png";